import { render, staticRenderFns } from "./Sitemap.vue?vue&type=template&id=2b0bfc20&scoped=true&"
import script from "./Sitemap.vue?vue&type=script&lang=js&"
export * from "./Sitemap.vue?vue&type=script&lang=js&"
import style0 from "./Sitemap.vue?vue&type=style&index=0&id=2b0bfc20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0bfc20",
  null
  
)

export default component.exports